export default __webpack_public_path__ + "static/media/baby-3.c8324372.png";